import ds from './DataSourceService'

const baseUrl = '/client-apps'

const createClientApp = data => {
  return ds.apiClientThinkHome.post(baseUrl, data)
}
const getClientAppsForUser = () => {
  return ds.apiClientThinkHome.get(baseUrl)
}
const getClientAppsForProject = projectId => {
  return ds.apiClientThinkHome.get(baseUrl + '?projectId=' + projectId)
}
const updateClientApp = data => {
  return ds.apiClientThinkHome.patch(baseUrl, data)
}
const getClientAppById = id => {
  return ds.apiClientThinkHome.get(baseUrl + '/' + id)
}

const deleteClientApp = id => {
  return ds.apiClientThinkHome.delete(baseUrl + '/' + id)
}
const getRootMenus = id => {
  return ds.apiClientThinkHome.get(baseUrl + '/' + id + '/root-menu')
}
const getMenuItems = id => {
  return ds.apiClientThinkHome.get(baseUrl + '/' + id + '/menu-items')
}

export default {
  createClientApp,
  getClientAppById,
  getClientAppsForUser,
  updateClientApp,
  deleteClientApp,
  getRootMenus,
  getMenuItems,
  getClientAppsForProject
}
